import { AppRestClient } from "@/util/rest/clients/app-rest-client";
import { z } from "zod";
import { ZodExtended } from "@/data/zod.extended";
import { CommonModels } from "@/data/common/common.models";
import { GuestProfileModels } from "./guestProfile.models";

export namespace GuestProfileApi {
export const requestPresignedUrl = (data: GuestProfileModels.GuestProfilePresignedUrlRequestDto, ) => { 
    return AppRestClient.post( 
        { resSchema: CommonModels.MediaUploadInstructionsSchema }, 
        `/guest-profile/presigned-url`,
        ZodExtended.parse(GuestProfileModels.GuestProfilePresignedUrlRequestDtoSchema, data)
, 
        
    )
};

export const submitResume = (data: GuestProfileModels.GuestProfileResumeSubmitRequestDto, ) => { 
    return AppRestClient.post( 
        { resSchema: z.void() }, 
        `/guest-profile/resume`,
        ZodExtended.parse(GuestProfileModels.GuestProfileResumeSubmitRequestDtoSchema, data)
, 
        
    )
};

export const submitManual = (data: GuestProfileModels.GuestProfileManualSubmitRequestDto, ) => { 
    return AppRestClient.post( 
        { resSchema: z.void() }, 
        `/guest-profile/manual`,
        ZodExtended.parse(GuestProfileModels.GuestProfileManualSubmitRequestDtoSchema, data)
, 
        
    )
};

export const getCurrent = () => { 
    return AppRestClient.get( 
        { resSchema: GuestProfileModels.GuestProfileResponseDtoSchema }, 
        `/guest-profile`,
        
    )
};

export const clear = () => { 
    return AppRestClient.delete( 
        { resSchema: z.void() }, 
        `/guest-profile`,
        
    )
};

export const shareByEmail = (data: GuestProfileModels.GuestProfileShareRequestDto, ) => { 
    return AppRestClient.post( 
        { resSchema: z.void() }, 
        `/guest-profile/share`,
        ZodExtended.parse(GuestProfileModels.GuestProfileShareRequestDtoSchema, data)
, 
        
    )
};

export const edit = (id: string, data: GuestProfileModels.GuestProfileEditRequestDto, ) => { 
    return AppRestClient.put( 
        { resSchema: GuestProfileModels.GuestProfileResponseDtoSchema }, 
        `/guest-profile/${id}/edit`,
        ZodExtended.parse(GuestProfileModels.GuestProfileEditRequestDtoSchema, data)
, 
        
    )
};

export const triggerWorthCalculation = (id: string, ) => { 
    return AppRestClient.post( 
        { resSchema: z.void() }, 
        `/guest-profile/${id}/worth-calculation`,
        
    )
};

}
